import { Typography } from "@mui/material";

export default function RecordCount({ count }) {
    if (count === undefined || count === null) return null;
    return (
        <Typography component="span" sx={{ ml: 1, fontSize: 16, fontWeight: 600, color: "text.secondary" }}>
            ({count})
        </Typography>
    );
}
